import React from "react";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/remove.svg";

const DeleteButton = ({
  onClick,
  style,
  className,
  iconColor = "#E92F2F",
  iconSize = 18,
  icon,
}) => {
  const iconWithProps = React.Children.map(icon, (child) =>
    React.cloneElement(child, {
      width: iconSize,
      height: iconSize,
      fill: iconColor,
    })
  );
  return (
    <button
      onClick={onClick}
      className={className}
      style={{
        backgroundColor: `${iconColor}2F`,
        ...style,
      }}
    >
      {icon ? (
        iconWithProps
      ) : (
        <DeleteIcon width={iconSize} height={iconSize} fill={iconColor} />
      )}
    </button>
  );
};

export default DeleteButton;
